<template>
  <v-card min-width="400" max-width="650">
    <v-toolbar dense flat>
      <v-toolbar-title>{{ $t("common.filters") }}</v-toolbar-title>
      <v-spacer />
      <v-btn
        v-if="has_active_filters"
        elevation="0"
        small
        @click="$emit('clear-filters')"
        data-testid="clinic_page_clear_filters"
      >
        {{ $t("common.clear_all") }}
      </v-btn>
    </v-toolbar>

    <v-divider />

    <v-card-text>
      <v-layout>
        <div style="min-width: 250px">
          <!-- Accepted Status Filter -->
          <h3>{{ $t("clinic_page.filters.status") }}</h3>
          <v-radio-group :value="filters.accepted_status" dense @change="update_filter('accepted_status', $event)">
            <v-radio :label="$t('clinic_page.filters.all')" value="all" />
            <v-radio :label="$t('clinic_page.filters.status_has_account')" value="accepted" />
            <v-radio :label="$t('clinic_page.filters.status_no_account')" value="not_accepted" />
          </v-radio-group>

          <!-- Assigned Exercises Filter -->
          <h3>{{ $t("clinic_page.filters.assigned_exercises") }}</h3>
          <v-radio-group :value="filters.assigned_exercises" dense @change="update_filter('assigned_exercises', $event)">
            <v-radio :label="$t('clinic_page.filters.all')" value="all" />
            <v-radio :label="$t('clinic_page.filters.has_exercises')" value="has_exercises" />
            <v-radio :label="$t('clinic_page.filters.no_exercises')" value="no_exercises" />
          </v-radio-group>

          <!-- Billing Type Filter -->
          <div v-if="!current_clinic.has_tag('free')">
            <h3>{{ $t("clinic_page.filters.billing_type") }}</h3>
            <v-radio-group :value="filters.billing_type" dense @change="update_filter('billing_type', $event)">
              <v-radio :label="$t('clinic_page.filters.all')" value="all" />
              <v-radio :label="$t('clinic_page.filters.free')" value="free" />
              <v-radio :label="$t('billing_payment.clinic_pays')" value="clinic" />
              <v-radio :label="$t('billing_payment.user_pays')" value="user" />
            </v-radio-group>
          </div>
        </div>

        <div style="min-width: 250px">
          <!-- Expiry Date Filter -->
          <h3>{{ $t("clinic_page.filters.expiry_date") }}</h3>
          <v-radio-group :value="filters.expiry_date" dense @change="update_filter('expiry_date', $event)">
            <v-radio :label="$t('clinic_page.filters.all')" value="all" />
            <v-radio :label="$t('clinic_page.filters.has_expiry')" value="has_expiry" />
            <v-radio :label="$t('clinic_page.filters.no_expiry')" value="no_expiry" />
          </v-radio-group>

          <!-- Owner Filter -->
          <h3>{{ $t("clinic_page.filters.assigned_staff") }}</h3>
          <v-select
            :value="filters.owner"
            class="mt-4"
            :items="owner_filter_options"
            dense
            outlined
            @change="update_filter('owner', $event)"
          />

          <!-- Latest Activity Filter -->
          <h3>{{ $t("clinic_page.filters.latest_activity") }}</h3>
          <v-select
            :value="filters.latest_activity"
            class="mt-4"
            :items="latest_activity_filter_options"
            dense
            outlined
            @change="update_filter('latest_activity', $event)"
          />
        </div>
      </v-layout>

      <v-expansion-panels class="mt-4">
        <v-expansion-panel>
          <v-expansion-panel-header>
            {{ $t("clinic_page.bulk_operations") }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-btn
              color="error"
              outlined
              :disabled="bulk_archive_candidate_count === 0"
              @click="$emit('bulk-archive')"
              data-testid="clinic_page_bulk_archive"
            >
              <v-icon left>mdi-archive</v-icon>
              {{ $t("clinic_page.bulk_archive") }}
            </v-btn>
            <div class="mt-2 text-caption">
              {{ bulk_archive_count_text }}
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    filters: {
      type: Object,
      required: true,
    },
    current_clinic: {
      type: Object,
      required: true,
    },
    owner_filter_options: {
      type: Array,
      required: true,
    },
    latest_activity_filter_options: {
      type: Array,
      required: true,
    },
    has_active_filters: {
      type: Boolean,
      required: true,
    },
    bulk_archive_candidate_count: {
      type: Number,
      required: true,
    },
  },
  computed: {
    bulk_archive_count_text() {
      if (this.bulk_archive_candidate_count === 0) {
        return this.$t("clinic_page.bulk_archive_no_candidates");
      }
      return this.$t("clinic_page.bulk_archive_candidate_count", { count: this.bulk_archive_candidate_count });
    },
  },
  methods: {
    update_filter(key, value) {
      this.$emit("update-filter", { key, value });
    },
  },
};
</script>
